<template>
  <form @submit.prevent="save_event" class="mt-8">

    <p style="font-weight: bold;">{{ $t('EVENT.NOTIFY_USER_IDS') }}</p>
    <Multiselect
      v-if="local_item.notif_user_ids"
      style="height: 48px;"
      class="multiselect-blue"
      v-model="local_item.notif_user_ids"
      ref="tickets_multiselect"
      mode="tags"
      :placeholder="$t('EVENT.SELECT_USERS')"
      :close-on-select="false"
      @input="users_changed"
      :options="users_options"
    />

    <div style="height: 400px;"></div>

  </form>
</template>

<script>
import Multiselect from '@vueform/multiselect/dist/multiselect.vue2.js'
import axios from 'axios';

export default {
  props: ['item'],
  components: {
    Multiselect
  },
  watch: {
    
    item: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        this.local_item = JSON.parse(JSON.stringify(this.item));
        
        if (!this.local_item.notif_user_ids) {
          this.local_item.notif_user_ids = [];
        }

        this.load_users();
      },
      immediate: true
    },

  },
  methods: {

    save_event() {},

    users_changed() {
      console.log('form has changed', this.local_item)
      this.$emit('change', this.local_item);
    },

    async load_users() {
      try {
        const res = await axios.get(`/access/users`);

        if (res.status === 200) {
          this.users_options = res.data.map(i => ({ label: i.email, value: i.user_id }));
        }
      }
      catch (err) {
        console.error('load_users error', err);
      }
      


    },
  },
  data() {
    return {
      
      users_options: [],
      local_item: {},

    }
  },
}
</script>
